module.exports = __webpack_public_path__ + "img/prenominas.88025360.svg";